export class InterestValue {

  static UNDEFINED = -1;
  static LIKES = 0;
  static DISLIKES = 1;
  static INTERESTED = 3;
}
